import { AbstractControl, ValidationErrors } from '@angular/forms';
import { formatDateToYYYYMMDD } from './format-Date-To-YYYY-MM-DD.helper';

export function dateNotInPastValidator(admin: boolean) {
  return (control: AbstractControl): ValidationErrors | null => {
    const rawValue = control.value;

    if (admin || !rawValue) {
      return null;
    }

    const formattedValue = rawValue instanceof Date ? formatDateToYYYYMMDD(rawValue) : rawValue;

    // Validate date format (YYYY-MM-DD)
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(formattedValue)) {
      return { invalidDateFormat: true };
    }
    const [year, month, day] = formattedValue.split('-').map(Number);
    if (year < 1000 || year > 9999 || month < 1 || month > 12 || day < 1 || day > 31) {
      return { invalidDateFormat: true };
    }
    const daysInMonth = new Date(year, month, 0).getDate();
    if (day > daysInMonth) {
      return { invalidDateFormat: true };
    }

    // Get today's date as YYYY-MM-DD
    const today = new Date();
    const todayString = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

    // Compare strings (treat today as invalid)
    return formattedValue < todayString ? { dateInPast: true } : null;
  };
}